<template>
  <button
    class="today-button"
    :class="btnClass"
    v-on="$listeners">
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    xl: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    btnClass() {
      const arrayClass = []
      if (this.xl) arrayClass.push('--xl')
      if (this.active) arrayClass.push('today-button--active')
      return arrayClass
    },
    btnImgStyle() {
      if (this.xl) return {width: '60px'}
      return {width: '45px'}
    }
  },
}
</script>

<style scoped lang="scss">
.today-button{
  position: relative;
  background-color: $l-blue;
  box-shadow: 1px 2px 6px $grey05;
  border-radius: 50%;
  border: none;
  width: 60px;
  height: 60px;
  padding: 0;

  color: $white;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  z-index: 9999;

  &--active{
    background-color: $blue;
  }

  &:active {
    background-color: $blue;
  }
}

.--xl {
  width: 80px;
  height: 80px;
  font-size: 14px;
}

.today-button-img {
  height: auto;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 40%;
}
</style>